<div class="config-registro-container">
  <div class="container-fluid py-4">
    <!-- Header con breadcrumb -->
    <div class="row mb-4">
      <div class="col-12">
        <app-breadcrumb-two></app-breadcrumb-two>
      </div>
    </div>

    <!-- Título y acciones -->
    <div class="row mb-4">
      <div class="col-md-8">
        <h3 class="page-title">
          {{ isEditMode ? 'Editar Configuración' : 'Nueva Configuración' }}
        </h3>
      </div>
      <div class="col-md-4 text-right">
        <button type="button" class="btn btn-secondary mr-2" (click)="cancel()">
          <i class="fa fa-times"></i> Cancelar
        </button>
        <button *ngIf="isEditMode" type="button" class="btn btn-info mr-2" (click)="duplicateConfig()">
          <i class="fa fa-copy"></i> Duplicar
        </button>
        <button *ngIf="isEditMode" type="button" class="btn btn-danger mr-2" (click)="deleteConfig()">
          <i class="fa fa-trash"></i> Eliminar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isLoading">
          <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : (isEditMode ? 'fa-save' : 'fa-plus')"></i> 
          {{ isLoading ? 'Guardando...' : (isEditMode ? 'Guardar' : 'Crear') }}
        </button>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="isLoadingConfig" class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p class="mt-3">Cargando configuración...</p>
    </div>

    <!-- Formulario principal -->
    <div *ngIf="isConfigLoaded && form" class="row">
      <div class="col-12">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="card shadow-sm">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0">Información Principal</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <!-- Nombre -->
                <div class="col-md-6 mb-3">
                  <label for="name" class="form-label">Nombre <span class="text-danger">*</span></label>
                  <input 
                    type="text" 
                    id="name" 
                    formControlName="name"
                    class="form-control"
                    [class.is-invalid]="hasError('name')"
                    placeholder="Ingrese el nombre">
                  <div class="invalid-feedback" *ngIf="hasError('name')">
                    {{ getErrorMessage('name') }}
                  </div>
                </div>

                <!-- Código -->
                <div class="col-md-6 mb-3">
                  <label for="code" class="form-label">Código <span class="text-danger">*</span></label>
                  <input 
                    type="text" 
                    id="code" 
                    formControlName="code"
                    class="form-control"
                    [class.is-invalid]="hasError('code')"
                    placeholder="Ingrese el código">
                  <div class="invalid-feedback" *ngIf="hasError('code')">
                    {{ getErrorMessage('code') }}
                  </div>
                </div>

                <!-- Descripción -->
                <div class="col-12 mb-3">
                  <label for="description" class="form-label">Descripción <span class="text-danger">*</span></label>
                  <textarea 
                    id="description" 
                    formControlName="description"
                    class="form-control"
                    rows="3"
                    [class.is-invalid]="hasError('description')"
                    placeholder="Ingrese una descripción detallada"></textarea>
                  <div class="invalid-feedback" *ngIf="hasError('description')">
                    {{ getErrorMessage('description') }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Configuración -->
          <div class="card shadow-sm mt-4">
            <div class="card-header bg-secondary text-white">
              <h5 class="mb-0">Configuración</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
                    <label class="form-check-label" for="isActive">Activo</label>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isVisible" formControlName="isVisible">
                    <label class="form-check-label" for="isVisible">Visible</label>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isOnline" formControlName="isOnline">
                    <label class="form-check-label" for="isOnline">En línea</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Tipo -->
                <div class="col-md-6 mb-3">
                  <label for="type" class="form-label">Tipo</label>
                  <select id="type" formControlName="type" class="form-select">
                    <option value="">Seleccione un tipo</option>
                    <option value="Trámite">Trámite</option>
                    <option value="Servicio">Servicio</option>
                    <option value="Consulta">Consulta</option>
                    <option value="Queja">Queja</option>
                  </select>
                </div>

                <!-- Categoría -->
                <div class="col-md-6 mb-3">
                  <label for="category" class="form-label">Categoría</label>
                  <input 
                    type="text" 
                    id="category" 
                    formControlName="category"
                    class="form-control"
                    placeholder="Ingrese la categoría">
                </div>
              </div>
            </div>
          </div>

          <!-- Contacto -->
          <div class="card shadow-sm mt-4">
            <div class="card-header bg-info text-white">
              <h5 class="mb-0">Información de Contacto</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="contactName" class="form-label">Nombre de contacto</label>
                  <input 
                    type="text" 
                    id="contactName" 
                    formControlName="contactName"
                    class="form-control"
                    placeholder="Ingrese el nombre del contacto">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="contactPhone" class="form-label">Teléfono</label>
                  <input 
                    type="text" 
                    id="contactPhone" 
                    formControlName="contactPhone"
                    class="form-control"
                    placeholder="Ingrese el teléfono">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="contactEmail" class="form-label">Email</label>
                  <input 
                    type="email" 
                    id="contactEmail" 
                    formControlName="contactEmail"
                    class="form-control"
                    [class.is-invalid]="hasError('contactEmail')"
                    placeholder="correo@ejemplo.com">
                  <div class="invalid-feedback" *ngIf="hasError('contactEmail')">
                    {{ getErrorMessage('contactEmail') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="address" class="form-label">Dirección</label>
                  <input 
                    type="text" 
                    id="address" 
                    formControlName="address"
                    class="form-control"
                    placeholder="Ingrese la dirección">
                </div>
              </div>
            </div>
          </div>

          <!-- Vigencia y Tiempos -->
          <div class="card shadow-sm mt-4">
            <div class="card-header bg-success text-white">
              <h5 class="mb-0">Vigencia y Tiempos</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label for="validityDays" class="form-label">Días de vigencia</label>
                  <input 
                    type="number" 
                    id="validityDays" 
                    formControlName="validityDays"
                    class="form-control"
                    min="0"
                    placeholder="0">
                </div>
                <div class="col-md-4 mb-3">
                  <label for="validityType" class="form-label">Tipo de vigencia</label>
                  <select id="validityType" formControlName="validityType" class="form-select">
                    <option value="Días naturales">Días naturales</option>
                    <option value="Días hábiles">Días hábiles</option>
                  </select>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="answerTime" class="form-label">Tiempo de respuesta (días)</label>
                  <input 
                    type="number" 
                    id="answerTime" 
                    formControlName="answerTime"
                    class="form-control"
                    min="0"
                    placeholder="0">
                </div>
              </div>
            </div>
          </div>

          <!-- Información adicional -->
          <div class="card shadow-sm mt-4">
            <div class="card-header bg-warning text-dark">
              <h5 class="mb-0">Información Adicional</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="office" class="form-label">Oficina</label>
                  <input 
                    type="text" 
                    id="office" 
                    formControlName="office"
                    class="form-control"
                    placeholder="Ingrese la oficina">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="location" class="form-label">Ubicación</label>
                  <input 
                    type="text" 
                    id="location" 
                    formControlName="location"
                    class="form-control"
                    placeholder="Ingrese la ubicación">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="schedule" class="form-label">Horario</label>
                  <input 
                    type="text" 
                    id="schedule" 
                    formControlName="schedule"
                    class="form-control"
                    placeholder="Ej: Lunes a Viernes 9:00 - 18:00">
                </div>
                <div class="col-12 mb-3">
                  <label for="notes" class="form-label">Notas</label>
                  <textarea 
                    id="notes" 
                    formControlName="notes"
                    class="form-control"
                    rows="3"
                    placeholder="Ingrese notas adicionales"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Metadata (solo en modo edición) -->
          <div *ngIf="isEditMode && configData" class="card shadow-sm mt-4">
            <div class="card-header bg-dark text-white">
              <h5 class="mb-0">Metadatos</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <strong>Creado:</strong> {{ formatDate(configData.created_at) }}
                </div>
                <div class="col-md-4">
                  <strong>Actualizado:</strong> {{ formatDate(configData.updated_at) }}
                </div>
                <div class="col-md-4">
                  <strong>ID:</strong> {{ configData.id }}
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

